import styled from "styled-components";
import { LinearProgress, Select, TableCell, TableContainer as MuiTableContainer } from '@mui/material';

export const Sections = styled.div`
  display: flex;
  padding: 2% 4%;
  @media (max-width: 750px) {
    flex-direction: column;
  }
`;

export const CenterPageSection = styled.div`
  width: 100%;
  margin-bottom: 1%;
  @media (max-width: 750px) {
    width: 100%;
  }
`;

export const MainContainer = styled.div`
  width: 100%;
  background-color: #fff;
`;

export const BackButtonContainer = styled.div`
  margin-bottom: 1rem;
`;

export const DetailContainer = styled.div`
  margin: 0 auto;
  padding:  2rem;
`;

export const Card = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-start;
    background: #ffffff;
    box-shadow: 0rem 0.237rem 0.237rem rgba(0, 0, 0, 0.25);
    border-radius: 0.375rem;
`;

export const CardTitle = styled.p`
    font-weight: 600;
    font-size: 1.125rem;
`;

export const CardNumber = styled.p`
    margin-left: 0.75rem;
    color: #fe2f67;
    font-weight: 600;
    font-size: 2.1875rem;
`;

export const CardTag = styled.p`
    margin-left: 0.75rem;
    font-weight: 400;
    color: #606770;
    font-size: 0.875rem;
`;

export const ProgressBar = styled(LinearProgress)`
    margin-left: 0.75rem;
    & .MuiLinearProgress-bar {
        background-color: rgba(254, 47, 103, 1);
    }
    background-color: rgba(254, 47, 103, 0.09) !important;
    border-radius: 0.625rem;
    min-height: 1rem;
    width: 90%;
`;

export const DonorCardList = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    overflow-y: scroll;
    align-items: center;

    scrollbar-width: thin;
    scrollbar-color: #fe2f67 #f1f1f1;

    &::-webkit-scrollbar {
        width: 0.5rem;
    }
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 0.625rem;
    }
    &::-webkit-scrollbar-thumb {
        background: #fe2f67;
        border-radius: 0.625rem;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #e8245a;
    }
`;

export const DonorCard = styled.div`
    width: 12.5rem;
    height: 3.4375rem;
    min-height: 3.4375rem;
    max-height: 3.4375rem;
    min-width: 12.5rem;
    max-width: 12.5rem;
    background: #F7F4F4;
    margin-top: 0.5rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-left: 3rem !important;
    text-align: left !important;
`;

export const DonorCardTitle = styled.p`
    font-weight: 400;
    font-size: 0.875rem;
`;

export const DonorCardNumber = styled.p`
    font-weight: 600;
    font-size: 0.75rem;
    color: #fe2f67;
`;

export const DonorCardTag = styled.p`
    font-weight: 400;
    font-size: 0.75rem;
    color: #8F8F8F;
`;

export const IntervalSelect = styled(Select)`
    width: 5.625rem;
    height: 1.75rem;
    border-radius: 0.375rem;
    font-size: 0.75rem;
    & .MuiSelect-select {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        font-size: 0.75rem;
    }
    & .MuiSelect-selectMenu {
        font-size: 0.75rem;
    }
    & .MuiSelect-root {
        font-weight: 400;
        font-size: 0.75rem;
    }
    & .MuiSelect-select:focus {
        font-size: 0.75rem;
    }
    & .MuiSelect-select:focus-visible {
        font-size: 0.75rem;
    }
    & .MuiSelect-selectMenu:focus {
        font-size: 0.75rem;
    }
`;

export const SearchBarBox = styled.div`
    display: flex;
    align-items: center;
    background-color: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 0.5rem;
    padding: 0.5rem 0.75rem;
`;

export const SearchFilterButton = styled.button`
    height: 2rem;
    border-radius: 0.25rem;
    border: 1px solid #C4C4C4;
    font-weight: 400;
    font-size: 0.875rem;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #707070;
    cursor: pointer;
    padding: 0 0.75rem;
    margin-left: 0.5rem;

    &:hover {
        background-color: #f5f5f5;
    }
`;

export const Font12pxRegular = styled.p`
    font-weight: 400;
    font-size: 0.75rem;
`;

export const Font12pxBold = styled.p`
    font-weight: 600;
    font-size: 0.75rem;
`;

export const Font14pxRegular = styled.p`
    font-weight: 400;
    font-size: 0.875rem;
`;

export const Font14pxBold = styled.p`
    font-weight: 500;
    font-size: 0.875rem;
`;

export const TableCellCondensed = styled(TableCell)`
    padding-top: 0.625rem !important;
    padding-bottom: 0.625rem !important;
    padding-left: 3rem !important;
    text-align: left !important;
`;

export const StyledTableContainer = styled(MuiTableContainer)`
    scrollbar-width: thin;
    scrollbar-color: #fe2f67 #f1f1f1;

    &::-webkit-scrollbar {
        width: 0.5rem;
    }
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 0.625rem;
    }
    &::-webkit-scrollbar-thumb {
        background: #fe2f67;
        border-radius: 0.625rem;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #e8245a;
    }
`;

export const TableFooterStyled = styled.div`
  background: #faf7fa;
  border-top: 1px solid #f3c2d1;
  padding: 0.5rem 1.5rem;
  border-radius: 0 0 10px 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #fe2f67;
  font-weight: 700;
  
  .MuiTablePagination-root,
  .MuiTablePagination-toolbar,
  .MuiTablePagination-selectLabel,
  .MuiTablePagination-input,
  .MuiTablePagination-displayedRows,
  .MuiSelect-select,
  .MuiSvgIcon-root {
    color: #fe2f67 !important;
    fill: #fe2f67 !important;
    font-weight: 700 !important;
  }
  
  .MuiTablePagination-actions button {
    color: #fe2f67 !important;
    font-weight: 700 !important;
  }
`;